export default __webpack_public_path__ + "education.2cd6ef11f522f1f3dc08ff25e2ce4211.jpg"